import React, { useEffect, useMemo, useState } from "react";

export default function Snowfall() {
  const [enabled, setEnabled] = useState(true);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setEnabled(!mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  const flakes = useMemo(() => {
    const count = 28;
    return Array.from({ length: count }).map((_, i) => {
      const left = Math.random() * 100;
      const dur = 16 + Math.random() * 12;
      const delay = Math.random() * 12;
      const drift = (Math.random() * 24 + 12) * (i % 2 === 0 ? 1 : -1);
      const size = 14 + Math.random() * 12;
      const opacity = 0.18 + Math.random() * 0.18;
      return { left, dur, delay, drift, size, opacity, id: i };
    });
  }, []);

  if (!enabled) return null;

  return (
    <div className="snowflakes" aria-hidden="true">
      {flakes.map((f) => (
        <span
          key={f.id}
          className="snowflake"
          style={{
            "--left": `${f.left}%`,
            "--dur": `${f.dur}s`,
            "--delay": `${f.delay}s`,
            "--drift": `${f.drift}px`,
            fontSize: `${f.size}px`,
            opacity: f.opacity,
          }}
        >
          ❄
        </span>
      ))}
    </div>
  );
}
